/**
 * The neon palette of the eighties look, shared by everything the canvas draws: the night sky
 * behind the world, the world's blocks and water and bars, the ninja's body, the popups, and the
 * debug shapes. The stylesheet's tokens ("The retro theme" in packages/app/src/style.css) carry the
 * same colors for the DOM, so a menu and the game behind it agree. Change a color here and in the
 * stylesheet together.
 */

export const NEON = {
  /** The darkest night: the canvas background and the bottom of the sky. */
  night: 0x0a0416,
  /** The sky, top to bottom: the zenith, the mid sky, the band above the horizon, the horizon itself, and the ground haze below it. */
  skyTop: 0x03010a,
  skyMid: 0x10063a,
  skyLow: 0x3a0c6e,
  horizon: 0x8a1c8e,
  belowHorizon: 0x160538,
  /** Ink: the darkest solid, used for text strokes and the checkered flag. */
  ink: 0x0a0416,
  pink: 0xff2d95,
  cyan: 0x2de2ff,
  yellow: 0xffe600,
  orange: 0xff8c1a,
  purple: 0x9d4edd,
  green: 0x39ff14,
  /** Paper: the ninja's body and the light squares of the finish. */
  paper: 0xf4f1ea,
  dim: 0xb8a9d9,

  /** The world: dark blocks with a lit top edge, the color of the edge telling what the block is. */
  ground: 0x2c1358,
  groundEdge: 0x2de2ff,
  box: 0x5a2d9c,
  boxEdge: 0xff2d95,
  pipe: 0xff2d95,
  pipeEdge: 0xf4f1ea,
  water: 0x1c3fd0,
  waterDeep: 0x0d1e78,
  waterEdge: 0x73eff7,
  bar: 0xffe600,
  barPost: 0x2de2ff,
  startLine: 0x39ff14,
  /** The far ridge and the near skyline behind the world, and the sun's top and bottom. */
  ridgeFar: 0x1a0640,
  ridgeFarEdge: 0xff2d95,
  ridgeNear: 0x0c0322,
  ridgeNearEdge: 0x2de2ff,
  sunTop: 0xffe600,
  sunBottom: 0xff2d95,
} as const;

/** The pixel typefaces of the look (bundled by the app as @fontsource packages; the app loads them before drawing text). */
export const PIXEL_FONT = "Press Start 2P";
export const TERM_FONT = "VT323";

/** "#rrggbb" for a palette color (the DOM side of a color chosen on the canvas). */
export function cssHex(color: number): string {
  return `#${color.toString(16).padStart(6, "0")}`;
}
